// Logs.js
import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { LeftSide } from '../../components/LeftSide/LeftSide';
import { Navi } from '../../components/Navi/Navi';
import { RightBar } from '../../components/RightBar/RightBar';
import { toKST } from '../../utils/date';
import '../../styles/common.css';
import '../Users/User.css';
import api from '../../utils/api';
import * as bootstrap from 'bootstrap';
import { toast } from 'react-toastify';
import { useMinLoadingDisplay } from '../../hooks/useMinLoadingDisplay';

const LoginLogs = ({ title = '접속로그' }) => {
    const [histories, setHistories] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(50);
    const [totalPages, setTotalPages] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [typeFilter, setTypeFilter] = useState('');
    const [sortOrder, setSortOrder] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const showListLoading = useMinLoadingDisplay(isLoading);
    const [modalContent, setModalContent] = useState(null);
    const [modalTitle, setModalTitle] = useState('');

    const fetchHistories = async (
        page = currentPage,
        search = searchTerm,
        type = typeFilter,
        sort = sortOrder
    ) => {
        setIsLoading(true);
        try {
            const res = await api.get('/logs/loginhistories', {
                params: { page, limit: itemsPerPage, search, type, sort },
            });

            if (res.data.success) {
                setHistories(res.data.histories);
                setTotalPages(Math.ceil(res.data.total / itemsPerPage));
            } else {
                toast.error(
                    res.data.message || '접속로그를 불러오지 못했습니다.'
                );
                console.error('데이터를 불러오지 못했습니다:', res.data.message);
            }
        } catch (err) {
            const msg =
                err?.response?.data?.message || '접속로그를 불러오는 중 오류가 발생했습니다.';
            toast.error(msg);
            console.error('접속로그 데이터 가져오기 실패:', err);
        } finally {
            setIsLoading(false);
        }
    };

    const handleSearch = e => setSearchTerm(e.target.value);
    const handleTypeFilter = e => {
        setTypeFilter(e.target.value);
        setCurrentPage(1);
    };
    const handleKeyPress = e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            setCurrentPage(1);
            fetchHistories(1, searchTerm, typeFilter, sortOrder);
        }
    };
    const resetSearch = () => {
        setSearchTerm('');
        setTypeFilter('');
        setSortOrder('');
        setCurrentPage(1);
        fetchHistories(1, '', '', '');
    };

    const handlePageChange = page => setCurrentPage(page);

    const renderPagination = () => {
        const pages = [];
        let start = Math.max(1, currentPage - 5);
        let end = Math.min(totalPages, start + 9);
        if (end - start < 9 && totalPages > 10) start = Math.max(1, end - 9);
        for (let i = start; i <= end; i++) pages.push(i);

        const pageBtn = (page, label, disabled = false, icon = false) => (
            <li className={`page-item ${disabled ? 'disabled' : ''}`}>
                <Link
                    className="page-link"
                    onClick={e => {
                        e.preventDefault();
                        if (!disabled) handlePageChange(page);
                    }}
                    title={icon ? label : undefined}
                >
                    {icon ? <i className={label}></i> : label}
                </Link>
            </li>
        );

        return (
            <nav aria-label="접속 내역 페이지네이션">
                <ul className="pagination pagination-sm justify-content-center mt-3">
                    {pageBtn(1, 'fas fa-angle-double-left', currentPage === 1, true)}
                    {pageBtn(currentPage - 1, '이전', currentPage === 1)}
                    {pages.map(num => (
                        <li
                            key={num}
                            className={`page-item ${currentPage === num ? 'active' : ''}`}
                        >
                            <Link
                                className="page-link"
                                onClick={e => {
                                    e.preventDefault();
                                    handlePageChange(num);
                                }}
                            >
                                {num}
                            </Link>
                        </li>
                    ))}
                    {pageBtn(currentPage + 1, '다음', currentPage === totalPages)}
                    {pageBtn(
                        totalPages,
                        'fas fa-angle-double-right',
                        currentPage === totalPages,
                        true
                    )}
                </ul>
            </nav>
        );
    };

    useEffect(() => {
        fetchHistories();
    }, [currentPage]);

    const showModal = (title, content) => {
        setModalTitle(title);
        setModalContent(content);
        const modal = new bootstrap.Modal(document.getElementById('infoModal'));
        modal.show();
    };

    return (
        <>
            <div id="wrapper">
                <Navi title={title} />
                <LeftSide />
                <div className="content-page">
                    <div className="content">
                        <div className="container-fluid users-admin-page">
                            <div className="row">
                                <div className="col-xl-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-3">
                                                <div className="d-flex flex-wrap align-items-center gap-1">
                                                    <input
                                                        type="text"
                                                        className="form-control form-control-sm"
                                                        placeholder="사용자 검색"
                                                        value={searchTerm}
                                                        onChange={handleSearch}
                                                        onKeyPress={handleKeyPress}
                                                        style={{ width: '200px' }}
                                                    />
                                                    <button
                                                        className="btn btn-primary btn-sm"
                                                        onClick={() =>
                                                            fetchHistories(
                                                                1,
                                                                searchTerm,
                                                                typeFilter,
                                                                sortOrder
                                                            )
                                                        }
                                                    >
                                                        <i className="fas fa-search" /> 검색
                                                    </button>
                                                    <button
                                                        className="btn btn-secondary btn-sm"
                                                        onClick={resetSearch}
                                                    >
                                                        <i className="fas fa-sync-alt" /> 초기화
                                                    </button>
                                                </div>
                                            </div>

                                            <div
                                                className="table-responsive"
                                                style={{ overflowX: 'auto' }}
                                            >
                                                {showListLoading ? (
                                                    <div className="text-center p-4">
                                                        <div
                                                            className="loading-spinner loading-spinner-lg"
                                                            role="status"
                                                            aria-live="polite"
                                                        >
                                                            <span className="visually-hidden">
                                                                데이터를 불러오는 중입니다.
                                                            </span>
                                                        </div>
                                                        <p className="mt-2">
                                                            데이터를 불러오는 중입니다...
                                                        </p>
                                                    </div>
                                                ) : (
                                                    <table className="table table-bordered table-hover table-sm align-middle text-nowrap">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th
                                                                    className="text-center"
                                                                    width="15%"
                                                                    style={{ whiteSpace: 'nowrap' }}
                                                                >
                                                                    번호
                                                                </th>
                                                                <th
                                                                    className="text-center"
                                                                    width="17%"
                                                                    style={{ whiteSpace: 'nowrap' }}
                                                                >
                                                                    사용자 아이디
                                                                </th>
                                                                <th
                                                                    className="text-center"
                                                                    width="57%"
                                                                >
                                                                    내역
                                                                </th>
                                                                <th
                                                                    className="text-center"
                                                                    width="17%"
                                                                    style={{ whiteSpace: 'nowrap' }}
                                                                >
                                                                    정보
                                                                </th>
                                                                <th
                                                                    className="text-center"
                                                                    width="15%"
                                                                    style={{ whiteSpace: 'nowrap' }}
                                                                >
                                                                    조회 날짜
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {histories.map((h, idx) => (
                                                                <tr key={h.id}>
                                                                    <td
                                                                        className="text-center"
                                                                        style={{
                                                                            whiteSpace: 'nowrap',
                                                                        }}
                                                                    >
                                                                        {totalPages > 0
                                                                            ? (totalPages -
                                                                                  currentPage) *
                                                                                  itemsPerPage +
                                                                              (histories.length -
                                                                                  idx)
                                                                            : 0}
                                                                    </td>
                                                                    <td
                                                                        className={
                                                                            h.user_id_attempt
                                                                                ? 'text-center users-admin-col-id'
                                                                                : 'text-center'
                                                                        }
                                                                        style={{
                                                                            whiteSpace: 'nowrap',
                                                                        }}
                                                                    >
                                                                        {h.user_id_attempt
                                                                            ? `${h.user_id_attempt} (${h.user_name})`
                                                                            : h.user_name}
                                                                    </td>
                                                                    <td
                                                                        className="text-center"
                                                                        style={{
                                                                            whiteSpace: 'nowrap',
                                                                        }}
                                                                    >
                                                                        {h.success === 1 ? (
                                                                            <span className="text-primary">
                                                                                접속 성공
                                                                            </span>
                                                                        ) : (
                                                                            <span className="text-danger">
                                                                                {h.failure_reason}
                                                                            </span>
                                                                        )}
                                                                    </td>{' '}
                                                                    <td
                                                                        className="text-center"
                                                                        style={{
                                                                            whiteSpace: 'nowrap',
                                                                        }}
                                                                    >
                                                                        <button
                                                                            className="btn btn-link p-0 me-2"
                                                                            title="브라우저 정보"
                                                                            onClick={() =>
                                                                                showModal(
                                                                                    '브라우저 정보',
                                                                                    h.user_agent
                                                                                )
                                                                            }
                                                                        >
                                                                            <i className="fas fa-globe"></i>
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-link p-0"
                                                                            title="디바이스 정보"
                                                                            onClick={() =>
                                                                                showModal(
                                                                                    '디바이스 정보',
                                                                                    JSON.stringify(
                                                                                        h.device_info,
                                                                                        null,
                                                                                        2
                                                                                    )
                                                                                )
                                                                            }
                                                                        >
                                                                            <i className="fas fa-desktop"></i>
                                                                        </button>
                                                                    </td>
                                                                    <td
                                                                        className="text-center"
                                                                        style={{
                                                                            whiteSpace: 'nowrap',
                                                                        }}
                                                                    >
                                                                        {toKST(h.timestamp)}
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                )}
                                            </div>

                                            {!showListLoading && renderPagination()}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <RightBar />
            <div className="rightbar-overlay" />
            {/* 모달 */}
            <div
                className="modal fade"
                id="infoModal"
                tabIndex="-1"
                aria-labelledby="infoModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog-centered admin-form-modal">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="infoModalLabel">
                                {modalTitle}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                                {modalContent}
                            </pre>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export { LoginLogs };
